import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Overlay = styled.div`
  position: absolute;
  top: 0;
  content: '';
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: ${COLORS.primary};
  border-radius: 2px;
  transition: opacity 0.15s;

  .active & {
    opacity: 0.3;
  }
`;

export default Overlay;
